import { motion } from 'framer-motion';
import type { Skill } from '../types';

interface SkillMeterProps {
  skill: Skill;
  index: number;
}

const SkillMeter = ({ skill, index }: SkillMeterProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className="mb-6"
    >
      <div className="flex justify-between items-center mb-2">
        <span className="text-white/85 font-medium text-sm">{skill.name}</span>
        <span className="text-accent font-semibold text-sm">{skill.level}%</span>
      </div>
      <div className="h-2 bg-white/10 rounded-full overflow-hidden">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${skill.level}%` }}
          transition={{ duration: 1.2, delay: index * 0.1 + 0.3, ease: 'easeOut' }}
          className="h-full bg-gradient-cta rounded-full"
        />
      </div>
      <span className="text-xs text-secondary mt-1 block">{skill.category}</span>
    </motion.div>
  );
};

export default SkillMeter;